import transformToCamelCase from '../../shared/transformers/toCamelCaseTransformer';
import transformReleaseActions from './transformReleaseActions';

export function transformRelease(release) {
  if (!release || !release.id) return {};

  const camelCasedRelease = transformToCamelCase(release);
  const {
    id,
    releaseState,
    committed,
    bundle,
    autoPublish,
    canPublish,
    canDeactivate,
    releasePublishState: publishState,
    creationDate: uploadDate,
    packages,
    stagedRollout,
    stagedRolloutPercentage,
    actions,
    releaseGroups,
  } = camelCasedRelease;

  let changelogEn = '';
  let changelogFa = '';
  if (packages.length) {
    const lastChild = packages[packages.length - 1];
    lastChild.isLastChild = true;
    changelogEn = lastChild.changelogEn;
    changelogFa = lastChild.changelogFa;
  }

  const transformedActions = transformReleaseActions(actions);

  return {
    token: id,
    releaseState,
    autoPublish,
    bundle,
    canPublish,
    publishState,
    committed,
    uploadDate,
    packages,
    changelogEn,
    changelogFa,
    canDeactivate,
    stagedRollout,
    stagedRolloutPercentage,
    actions: transformedActions,
    releaseGroups,
  };
}

export function transformReleases(releases) {
  if (!releases || !Array.isArray(releases)) {
    return [];
  }

  const transformedReleases = releases.map(transformRelease);

  if (transformedReleases.length) {
    transformedReleases[0].isLastRelease = true;
  }
  return transformedReleases;
}
